import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

export const ProfileManagementListContext = createContext(
  {},
);

export const ProfileManagementListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      name: undefined,
      group: undefined,
      role: undefined,
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions(oldValue => ({
      ...oldValue,
      filterParams: params
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions(oldValue => ({
      ...oldValue,
      pagination: paginationOption
    }));
  }, []);

  return (
    <ProfileManagementListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </ProfileManagementListContext.Provider>
  );
};

export function useProfileManagementList() {
  const context = useContext(ProfileManagementListContext);

  if (!context) {
    throw new Error('useProfileManagementList must be used within an ProfileManagementListProvider.');
  }

  return context;
}
